module.exports = __webpack_public_path__ + "static/media/grace.515420f7.jpeg";